export default __webpack_public_path__ + "static/media/ListAdd.84ac64ff.svg";